import React from 'react';
import { Button } from '@consta/uikit/Button';
import { Text } from '@consta/uikit/Text';
import { IconAdd } from '@consta/icons/IconAdd';
import classes from './style/FieldHeader.module.scss'

interface FieldHeaderProps {
    onAddField: () => void;
}

const FieldHeader: React.FC<FieldHeaderProps> = ({ onAddField }) => {
    return (
        <div className={classes.header}>
            <Text size='2xl' weight='bold'>Месторождения</Text>
            <Button iconLeft={IconAdd} label="Добавить месторождение" onClick={onAddField} size='s' />
        </div>
    );
};

export default FieldHeader;